import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      display: 'flex',
      flexFlow: 'column nowrap',
      gap: theme.spacing(2),
    },
    sectionTitle: {
      color: COLORS.gray.gray30,
      fontWeight: theme.typography.fontWeightMedium,
    },
    formatsList: {
      display: 'flex',
      flexFlow: 'column nowrap',
      gap: theme.spacing(2),
    },
    complianceBox: {
      background: COLORS.neutral.white,
      border: theme.shape.borderGray70,
      borderRadius: theme.shape.borderRadiusSemiLarge,
      padding: theme.spacing(2),
      boxShadow: 'none',
    },
    formatSection: {
      padding: theme.spacing(2),
    },
    formatTitle: {
      marginBottom: theme.spacing(1.5),
    },
    formatName: {
      marginBottom: theme.spacing(1.5),
      color: COLORS.neutral.secondary,
      fontWeight: theme.typography.fontWeightRegular,
      backgroundColor: COLORS.gray.gray80,
      borderRadius: theme.shape.borderRadiusMedium,
      padding: theme.spacing(0.5, 1),
      display: 'inline-block',
      width: 'fit-content',
    },
    violationsList: {
      display: 'flex',
      flexFlow: 'column nowrap',
      gap: theme.spacing(1),
      marginBottom: theme.spacing(2),
    },
    detectedViolation: {
      width: '100%',
      backgroundColor: 'transparent',
      border: 'none',
      borderBottom: theme.shape.borderGray70,
      padding: theme.spacing(1, 0),
      borderRadius: 0,
    },
    button: {
      width: 'fit-content',
      marginLeft: 'auto',
      display: 'block',
    },
  }),
  { name: 'FormatComplianceIssues' }
);
